export default __webpack_public_path__ + "static/media/tooltip-numero-servicio.1c82e67d.png";